import { call, select } from "redux-saga/effects";

import EntityType from "@mapmycustomers/shared/enum/EntityType";
import HasSourceObject from "@mapmycustomers/shared/types/base/HasSourceObject";
import Identified from "@mapmycustomers/shared/types/base/Identified";
import SourceObjectValue from "@mapmycustomers/shared/types/SourceObjectValue";

import i18nService from "@app/config/I18nService";
import { getSourceObjectMessageArgs, SourceObjectMessageArgs } from "@app/util/ui";

import { getSourceObjectValues } from "./selectors";

// The saga twin of useSourceObjectMessageArgs: message args for one record's type
export function* selectSourceObjectMessageArgs(
  entityType: EntityType,
  key: HasSourceObject["sourceObject"] | undefined
) {
  const values: SourceObjectValue[] = yield select(getSourceObjectValues, entityType);
  const args: SourceObjectMessageArgs = getSourceObjectMessageArgs(
    i18nService.getIntl(),
    entityType,
    values,
    key
  );
  return args;
}

// Message args for the record in an action. A record card or the map acts without the pane, which
// may be empty or hold another record, so the pane's type counts only when it holds that record.
export function* selectPaneSourceObjectMessageArgs(
  entityType: EntityType,
  paneRecord: (HasSourceObject & Identified) | undefined,
  id: Identified["id"]
) {
  const args: SourceObjectMessageArgs = yield call(
    selectSourceObjectMessageArgs,
    entityType,
    paneRecord?.id === id ? paneRecord.sourceObject : undefined
  );
  return args;
}
